import React from 'react';

const Icon = () => (
  <g>
    <path
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
      fill="#F0F0F0"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M0 7C0 3.13403 3.13403 0 7 0C10.866 0 14 3.13403 14 7"
      fill="#A2001D"
      transform="scale(1.71 1.71)"
    />
  </g>
);

export default Icon;
